<template>
    <div class="footer">
        <div class="footer-wrapper">
            <!-- <p class="footer-top" v-show="!isPhone">联盟单位</p>
            <p class="footer-union-orgs" v-show="!isPhone">
                <ul>
                    <li v-for="(item, i) in unionOrgs" :key="i">
                        <a :href="item.href" target="_blank">{{item.name}}
                            <span v-show="i < unionOrgs.length - 1" class="aline">|</span>
                        </a>
                    </li>
                </ul>
            </p>
            <p class="footer-top" v-show="!isPhone">成员单位</p>
            <p class="footer-union-deps" v-show="!isPhone">
                <ul>
                    <li v-for="(item, i) in unionDeps" :key="i">
                        <span>{{item}}</span>
                        <span v-show="i < unionDeps.length - 1" class="aline">|</span>
                    </li>
                </ul>
            </p> -->
            <p class="footer-top" v-show="!isPhone">友情链接</p>
            <p class="footer-union-orgs" v-show="!isPhone">
                <ul>
                    <li v-for="(item, i) in unionLinks" :key="i">
                        <a :href="item.href" target="_blank">{{item.name}}
                            <span v-show="i < unionLinks.length - 1" class="aline">|</span>
                        </a>
                    </li>
                </ul>
            </p>
            <p class="footer-host">四川互联网举报辟谣平台——中共四川省委网信办主管主办</p>
            <p class="footer-licence">
                <a v-show="!isScPiyaoOrgCn" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010402000435" target="_blank">
                    <img src="http://wapcdn.thecover.cn/web/20170913/police_record.png" style="width: auto; vertical-align: middle" />
                    川公网安备 51010402000435号</a>
                <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备15028104号-{{beianNum}}</a>
            </p>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import unionData from './../utils/unionData'
export default {
    name: 'Footer',
    computed: {
        ...mapState(['columnList']),
        isPhone() {
            return this.$Common.Attribute.isMb();
        },
        unionOrgs() {
            return unionData.unionOrgs
        },
        unionDeps() {
            return unionData.unionDeps
        },
        isProduction() {
            return location.host == 'piyao-web.thecover.cn' || location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn'
        },
        cyLocationHref() {
            if(this.isProduction) return 'https://piyao-web.thecover.cn/cy';
            else return 'https://piyao-web.fm-dev.thecover.cn/cy';
        },
        unionLinks() {
            return unionData.unionLinks.concat([{
                name: '川渝互联网辟谣平台',
                href: this.cyLocationHref,
            }])
        },
        beianNum() {
            if (location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn') {
                return unionData.scpiyaoOrgCn.beianNumber
            } else {
                return unionData.piyaoWeb.beianNumber
            }
        },
        isScPiyaoOrgCn() {
            return location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn'
        }
    },
}
</script>
<style lang="less">
.pc-wrapper {
    .footer {
        .footer-wrapper {
            width: 100%;
            background: #F7F8F9;
            text-align: center;
            padding: 1.8125rem 0.875rem 1rem;
            box-sizing: border-box;
            margin-top: 0.625rem;
            color: #333333;
            font-size: 0.875rem;
            .footer-top {
                margin-bottom: 0.625rem;
            }
            .footer-union-orgs {
                line-height: 1.25rem;
                margin-bottom: 1.375rem;
                ul {
                    li {
                        display: inline-block;
                        line-height: 1.575rem;
                        a {
                            color: inherit;
                            text-decoration: underline;
                        }
                    }
                }
            }
            .footer-union-deps {
                margin-bottom: 1.375rem;
                ul {
                    li {
                        display: inline-block;
                        line-height: 1.575rem;
                    }
                }
            }
            .aline {
                display: inline-block;
                // border-left: 1px solid #6e6e6d;
                // height: 0.875rem;
                margin: 0 0.3125rem;
            }
            .footer-host {
                color: #006DF1;
                margin-top: 1.375rem;
                margin-bottom: 1.375rem;
            }
            .footer-licence {
                color: #999999;
                font-size: 0.75rem;
                line-height: 1.125rem;
                a {
                    color: inherit;
                    text-decoration: none;
                    margin-right: 0.5rem;
                }
            }
        }
    }
}
.wap-wrapper {
    .footer {
        .footer-wrapper {
            width: 100vw;
            background: #F7F8F9;
            color: #727272;
            text-align: center;
            padding: 3.867vw 4.533vw 1.867vw;
            box-sizing: border-box;
            // margin-top: 4.267vw;
            .footer-top {
                margin-bottom: 1.333vw;
            }
            .footer-union-orgs {
                line-height: 4vw;
                margin-bottom: 2.933vw;
                color: #333333;
                ul {
                    li {
                        display: inline-block;
                        line-height: 1.375rem;
                        a {
                            color: inherit;
                            text-decoration: underline;
                        }
                    }
                }
            }
            .footer-union-deps {
                ul {
                    li {
                        display: inline-block;
                        line-height: 2.933vw;
                    }
                }
            }
            .aline {
                display: inline-block;
                margin: 0 0.533vw;
            }
            .footer-host {
                color: #727272;
                font-size: 3.2vw;
                line-height: 5.333vw;
                margin-top: 4.8vw;
                margin-bottom: 2.933vw;
            }
            .footer-licence {
                color: #999999;
                font-size: 2.667vw;
                line-height: 4.8vw;
                margin-bottom: 0.933vw;
                a {
                    color: inherit;
                    text-decoration: none;
                    margin-right: 1.333vw;
                }
            }
            .footer-version {
                color: #999999;
                font-size: 2.667vw;
                line-height: 3.733vw;
            }
        }
    }
}
</style>